import React from "react";

class HelperDiv extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        window.addEventListener('resize', this.calculateNewTops);
    }


  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateNewTops);
  }

    calculateNewTops = () => {
        let left;

        if (this.props.side === 'Left') {
            left = 0;
        } else {
            left = 100;
        }

        // The divs will spread evenly across the range of 33.33% to 66.66% of parent
        let distance = (100/3)/((this.props.recs.length)+1) 

        let spreads = this.props.recs.map((recs, index) => {

            let top = ((index + 1) * distance) + (100/3)

            // Xarrows will access these divs via ID
            return (
                <div
                id = {`helper-${index}-${this.props.side}`}
                style = {{
                    position: 'absolute',
                    top: `${top}%`,
                    left: `${left}%`,
                    height: '0',
                    width: '0'
                }}
                />
            );
        })

        return spreads;
    }


    
    render (){
        
        return(
            <div
            id = "parentofHelperDivs"
            >
            {this.calculateNewTops()}
            </div>
        );
    
    }
}

export default HelperDiv;
